import { TabDialects } from 'CMFW/layout/TabDialects';
import React from 'react';
import styled from 'styled-components';
import InflectConfigDialect from './InflectConfigDialect';

export type IProps = {
  keyName: string;
};

const InflectConfig: React.FC<IProps> = (props) => {
  return (
    <TabDialectsStyled keyName={props.keyName}>
      <InflectConfigDialect />
    </TabDialectsStyled>
  );
};

export default InflectConfig;

const TabDialectsStyled = styled(TabDialects)`
  && {
    height: 160px;
    flex-grow: unset;
  }
`;
